const widgetSegmentationSelector = '.js-steady_widget_segmentation';
const smartLayersSelector = '.js-smart_layers';
const countCheckoutLayerHitSelector = '.js-count_checkout_layer_hit';
const widgetSettingsSelector = '[data-steady-widget-settings][data-steady-widget-oauth]';
const newsletterEmbedSelector = '.js-steady_widget_newsletter_embed';
const logInSelector = 'a.js-sign_in';
const logOutSelector = 'a.js-sign_out';
window.up.compiler(widgetSettingsSelector, (_element, { steadyWidgetSettings, steadyWidgetOauth }) => {
    window.SteadyWidgetSettings = JSON.parse(steadyWidgetSettings);
    window.SteadyWidgetOAuth = Object.assign(Object.assign({}, JSON.parse(steadyWidgetOauth)), { signIn: () => {
            const loginLink = document.querySelector(logInSelector);
            if (loginLink) {
                window.up.follow(loginLink);
            }
        }, signOut: () => {
            const logoutLink = document.querySelector(logOutSelector);
            if (logoutLink) {
                logoutLink.click();
            }
        } });
});
window.up.compiler(widgetSegmentationSelector, () => {
    return window.SteadyWidget.initializeSegmentationData();
});
window.up.compiler(smartLayersSelector, (_element, { csrfToken, email, signedIn, joinUrl, joinCtaText }) => {
    const steadyNewsletterOptions = {
        csrfToken,
        source: 'newsletter_layer',
        email,
        signedIn: signedIn === 'true',
        joinUrl,
        joinCtaText
    };
    window.SteadyWidgetSettings = Object.assign(Object.assign({}, window.SteadyWidgetSettings), { steadyNewsletterOptions });
    return window.SteadyWidget.showLayer();
});
window.up.compiler(newsletterEmbedSelector, (_element, { csrfToken, source, origin, component, email, hideCloseButton, signedIn, joinUrl, joinCtaText }) => {
    const steadyNewsletterEmbedOptions = {
        csrfToken,
        source,
        origin,
        component,
        email,
        hideCloseButton: hideCloseButton === 'true',
        signedIn: signedIn === 'true',
        joinUrl,
        joinCtaText,
        alwaysVisible: true
    };
    // placing options in the global window means we should only have one newsletter embed per page
    window.SteadyWidgetSettings = Object.assign(Object.assign({}, window.SteadyWidgetSettings), { steadyNewsletterEmbedOptions });
    return window.SteadyWidget.initSteadyNewsletterEmbed();
});
// Same events as the widget's own checkout: loaded on render, shown once half of the
// plans section is in the viewport (STE-5342).
window.up.compiler(countCheckoutLayerHitSelector, element => {
    const oauth = window.SteadyWidgetOAuth;
    if (!oauth)
        return;
    window.SteadyWidget.hit(oauth, 'checkout', 'loaded');
    const viewObserver = window.SteadyWidget.onViewHitObserver(oauth, 'checkout');
    viewObserver.observe(element);
    return () => viewObserver.unobserve(element);
});
export {};
